/**
 * Where people write to Morcast, when the API publishes an address (`SUPPORT_EMAIL` in
 * `/api/config`): a line after a problem only Morcast can look into. Without an address the app
 * promises no contact, so the line is left out.
 */

import { useAppConfig } from "../config.js";
import { styles } from "./ui.js";

/** "If this keeps happening, write to support@…", or nothing without an address. */
export function SupportNote({ className = "" }: { className?: string }) {
  const { supportEmail } = useAppConfig();
  if (!supportEmail) {
    return null;
  }
  return (
    <p className={`text-xs text-zinc-500 dark:text-zinc-400 ${className}`}>
      If this keeps happening, write to <SupportLink email={supportEmail} />.
    </p>
  );
}

/** The support address as a link that opens a new email. */
export function SupportLink({ email }: { email: string }) {
  return (
    <a href={`mailto:${email}`} className={styles.link}>
      {email}
    </a>
  );
}
